// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RewardDetails_wrapper__EPXc1","wrapper__title":"RewardDetails_wrapper__title__tUI9a"};